import { ISetScheduleParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class SetSubscriptionsScheduleRequest extends Request<ISetScheduleParams, IResult> {
  constructor(ids: string[], scheduleId: string) {
    super('setSubscriptionsSchedule', {
      ids: ids,
      scheduleId: scheduleId
    });
  }
}
